import { createContext } from 'react';

import { State, createState } from '@hookstate/core';

import { IUpdateRawQueryList } from '@models/Update.model';
import { UpdatesLoading } from './Updates.loading';
import { UpdatesError } from './Updates.error';
import { UpdatesPrioritizedRaw } from './UpdatesPrioritized.raw';

export type SortUpdatesPrioritizedTypes =
  | 'assignee'
  | 'priority'
  | 'subject'
  | 'affects'
  | 'date'
  | 'dueDate'
  | 'count'
  | 'pManufacturers'
  | undefined;

export type DirectionUpdatesPrioritizedtypes = 'ASC' | 'DESC' | undefined;

interface IUpdatesPrioritizedContext {
  search: State<string>;
  sort: State<SortUpdatesPrioritizedTypes>;
  direction: State<DirectionUpdatesPrioritizedtypes>;
}

export const UpdatesPrioritizedContext =
  createContext<IUpdatesPrioritizedContext>({
    search: createState<string>(''),
    sort: createState<SortUpdatesPrioritizedTypes>(undefined),
    direction: createState<DirectionUpdatesPrioritizedtypes>(undefined),
  });

interface IUpdatesPrioritizedQuery {
  data: IUpdateRawQueryList[];
  isLoading: boolean;
  isError: boolean;
  hasMore?: boolean;
  loadMore: () => void;
}

const UpdatesPrioritizedQuery = ({
  data,
  isLoading,
  isError,
  loadMore,
  hasMore,
}: IUpdatesPrioritizedQuery) => {
  if (isLoading || !data) {
    return <UpdatesLoading />;
  }

  if (isError) {
    return <UpdatesError />;
  }

  return (
    <UpdatesPrioritizedRaw
      updateStatuses={data}
      loadMore={loadMore}
      hasMore={hasMore}
    />
  );
};

export { UpdatesPrioritizedQuery };
